import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { TPaginatedQuery } from '@/types';

export type AdditionalCompensations = {
  id: number;
  workerId: number;
  fullName: string;
  avatar: string;
  type: string;
  amount: string;
  currencyCode: string;
  description: string;
  status: string;
  createdAt: string;
  comment?: unknown;
  receipt?: string;
  reviewedAt?: unknown;
  reviewerName?: unknown;
};

export const getAdditionalCompensations = (
  page?: string,
  sort?: string,
  createdBetween?: string,
  type?: string
): Promise<TPaginatedQuery<AdditionalCompensations[]>> =>
  axios.get(`${API_BASE_PATH}/workers/additional-compensations`, {
    params: {
      'filter[status]': 'submitted',
      'filter[createdBetween]': createdBetween,
      'filter[type]': type,
      sort,
      page,
    },
  });

type QueryFnType = typeof getAdditionalCompensations;

type UseAdditionalCompensationsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAdditionalCompensations = ({ config }: UseAdditionalCompensationsOptions = {}) => {
  const [searchParams] = useSearchParams();

  const page = searchParams.get('page') || undefined;
  const sort = searchParams.get('sort') || undefined;
  const createdBetween = searchParams.get('filter[createdBetween]') || undefined;
  const type = searchParams.get('filter[type]') || undefined;

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['additional-compensations', page, sort, createdBetween, type],
    queryFn: () => getAdditionalCompensations(page, sort, createdBetween, type),
  });
};
